import { useRouter } from 'next/router';
import type { FC, ReactNode } from 'react';
import clsx from 'clsx';

import { getSubNavigation } from 'navigation/getSubNavigation';
import { AppLink } from 'types/AppLink';
import { StyledLink } from 'components/atoms/StyledLink';
import { ArrowLeftLine } from 'components/icons/System';
import { SkipToMainContentTarget } from 'components/molecules/SkipToMainContent';

import { SubNavigation } from './SubNavigation';
import Header from './Header';
import { Footer } from './Footer';

interface Props {
  navigation?: boolean;
  backNavigation?: AppLink;
  footerMargin?: boolean;
  contenWrapper?: boolean;
  children: ReactNode;
}

export const ViewMain: FC<Props> = ({
  children,
  navigation = true,
  backNavigation,
  footerMargin = true,
  contenWrapper = false,
}) => {
  const { asPath } = useRouter();
  const subNavigation = getSubNavigation(asPath);
  return (
    <div className="grid grid-cols-1 grid-rows-[min-content_1fr_min-content]">
      <Header />
      <div>
        {navigation && subNavigation && (
          <SubNavigation
            currentLink={subNavigation.currentLink}
            links={subNavigation.links}
          />
        )}
        <main
          className={clsx(
            'tablet:mt-12 min-h-[75vh]',
            contenWrapper && 'content-wrapper',
            footerMargin && 'mb-16 tablet:mb-30'
          )}
        >
          <SkipToMainContentTarget />
          {backNavigation && (
            <div className="content-wrapper">
              <StyledLink
                className="mb-14"
                link={backNavigation}
                iconPosition="left"
                icon={ArrowLeftLine}
                iconClassName="mr-4"
              />
            </div>
          )}
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};
